var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 398.393,
    height: 294.937,
    viewBox: "0 0 398.393 294.937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    transform: "translate(-1377.831 -416.558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(1363.549 330.973)",
    opacity: 0.37
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(69.131 153.042)",
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M-186.121,403.362c1.511-18.406,8.765-36.845,21.334-50.023,19.582-20.532,49.2-25.706,75.165-20.961,10.875,1.988,21.66,5.512,32.8,4.4,16.238-1.614,30.544-12.7,45.33-20.822,20.126-11.059,43.2-17.008,64.6-12.2a59.929,59.929,0,0,1,46.525,53.412c1.076,12.389-9.854,34.216-6.4,45.958,3.5,11.912,29.036,48.39,28.408,76.138-.628,27.645-6.51,36.242-14.821,50.29h-271.44c-5.177-14.235-9.229-25.622-3.17-44.315,4.842-14.937-8.314-27.236-13.4-41.142C-185.734,431.726-187.226,416.846-186.121,403.362Z",
    transform: "translate(186.469 -302.076)",
    fill: "#143a4d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(1377.831 416.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M-16.976,574.344l-172.885,1.387L-191.9,323.166a40.905,40.905,0,0,1,40.634-41.179l105.774-.849A40.912,40.912,0,0,1-4.2,321.66L-2.28,559.45A14.8,14.8,0,0,1-16.976,574.344Z",
    transform: "translate(228.901 -281.119)",
    fill: "#d4d8df"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 65.531,
    height: 289.628,
    transform: "translate(39.368 2.984)",
    fill: "#b3becc",
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(0 0.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M-21.874,281.19v-.048l-150.517,1.211c-17.324.139-31.249,14.9-31.1,32.976l.061,7.457a4.971,4.971,0,0,0,5.009,4.932l142.164-1.144a5.087,5.087,0,0,0,5.044-5.128l-.058-7.344C-51.416,296.627-38.4,282.247-21.874,281.19Z",
    transform: "translate(203.496 -281.142)",
    fill: "#b3becc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(71.819 66.285)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    y1: 0.309,
    x2: 38.367,
    transform: "translate(1.611 1.61)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M-179.59,305.245a1.609,1.609,0,0,1-1.611-1.6,1.611,1.611,0,0,1,1.6-1.624l38.368-.309a1.66,1.66,0,0,1,1.624,1.6,1.611,1.611,0,0,1-1.6,1.623l-38.369.309Z",
    transform: "translate(181.201 -301.714)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(72.183 110.745)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    y1: 1.084,
    x2: 76.177,
    transform: "translate(1.611 1.612)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M-179.477,319.823a1.61,1.61,0,0,1-1.611-1.585A1.612,1.612,0,0,1-179.5,316.6l76.18-1.086a1.612,1.612,0,0,1,1.633,1.588,1.614,1.614,0,0,1-1.591,1.633l-76.176,1.086Z",
    transform: "translate(181.088 -315.516)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(71.5 136.741)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    y1: 0.064,
    x2: 31.787,
    transform: "translate(1.612 1.61)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M-179.689,326.872a1.613,1.613,0,0,1-1.611-1.607,1.609,1.609,0,0,1,1.607-1.614l31.787-.064h0a1.61,1.61,0,0,1,1.611,1.607,1.609,1.609,0,0,1-1.607,1.614l-31.787.064Z",
    transform: "translate(181.3 -323.586)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(72 88.792)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    y1: 0.44,
    x2: 54.713,
    transform: "translate(1.613 1.609)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M-179.534,312.36a1.611,1.611,0,0,1-1.611-1.6,1.616,1.616,0,0,1,1.6-1.623l54.713-.438h.013a1.611,1.611,0,0,1,1.611,1.6,1.613,1.613,0,0,1-1.6,1.623l-54.716.438Z",
    transform: "translate(181.145 -308.701)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(139.978 88.628)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    y1: 0.057,
    x2: 7.102,
    transform: "translate(1.61 1.61)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M-158.431,311.929a1.613,1.613,0,0,1-1.611-1.6,1.611,1.611,0,0,1,1.6-1.624l7.1-.058h.013a1.611,1.611,0,0,1,1.611,1.6,1.613,1.613,0,0,1-1.6,1.624l-7.1.058Z",
    transform: "translate(160.042 -308.65)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(126.716 66.256)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    y1: 0.057,
    x2: 20.365,
    transform: "translate(1.609 1.611)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M-162.548,304.984a1.611,1.611,0,0,1-1.611-1.607,1.609,1.609,0,0,1,1.607-1.614l20.365-.058h0a1.613,1.613,0,0,1,1.611,1.607,1.611,1.611,0,0,1-1.607,1.614l-20.365.058Z",
    transform: "translate(164.159 -301.705)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(71.819 162.546)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    y1: 0.309,
    x2: 38.367,
    transform: "translate(1.611 1.612)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M-179.59,335.131a1.611,1.611,0,0,1-1.611-1.6,1.611,1.611,0,0,1,1.6-1.62l38.368-.312a1.653,1.653,0,0,1,1.624,1.6,1.611,1.611,0,0,1-1.6,1.624l-38.369.313Z",
    transform: "translate(181.201 -331.597)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189",
    transform: "translate(72.183 207.009)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    y1: 1.084,
    x2: 76.177,
    transform: "translate(1.611 1.611)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M-179.477,349.707a1.613,1.613,0,0,1-1.611-1.588,1.607,1.607,0,0,1,1.588-1.633l76.18-1.086a1.6,1.6,0,0,1,1.633,1.588,1.614,1.614,0,0,1-1.591,1.633l-76.176,1.086Z",
    transform: "translate(181.088 -345.4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190",
    transform: "translate(71.5 233.002)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    y1: 0.063,
    x2: 31.787,
    transform: "translate(1.612 1.612)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M-179.689,356.755a1.615,1.615,0,0,1-1.611-1.608,1.611,1.611,0,0,1,1.607-1.614l31.787-.064h0a1.613,1.613,0,0,1,1.611,1.607,1.607,1.607,0,0,1-1.607,1.614l-31.787.064Z",
    transform: "translate(181.3 -353.469)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191",
    transform: "translate(72 185.053)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    y1: 0.44,
    x2: 54.713,
    transform: "translate(1.613 1.611)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M-179.534,342.247a1.611,1.611,0,0,1-1.611-1.6,1.614,1.614,0,0,1,1.6-1.624l54.713-.441h.013a1.611,1.611,0,0,1,1.611,1.6,1.611,1.611,0,0,1-1.6,1.624l-54.716.441Z",
    transform: "translate(181.145 -338.584)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192",
    transform: "translate(139.978 184.889)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    y1: 0.057,
    x2: 7.102,
    transform: "translate(1.61 1.612)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M-158.431,341.812a1.611,1.611,0,0,1-1.611-1.6,1.611,1.611,0,0,1,1.6-1.624l7.1-.058h.013a1.613,1.613,0,0,1,1.611,1.6,1.611,1.611,0,0,1-1.6,1.623l-7.1.058Z",
    transform: "translate(160.042 -338.533)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(1476.938 542.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 243.154,
    height: 168.758,
    rx: 3.865,
    fill: "#143a4d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    transform: "translate(30.19 93.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M-134.979,355.48l-26.7.042c-.667,0-1.208-.4-1.211-.9l-.006-4.178c0-.5.541-.9,1.208-.905l26.7-.042c.67,0,1.211.4,1.211.9l.006,4.178C-133.767,355.074-134.309,355.477-134.979,355.48Z",
    transform: "translate(164.387 -349.334)",
    fill: "#e9f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M-124.358,355.463l-26.7.042c-.667,0-1.211-.4-1.211-.9l-.006-4.175c0-.5.541-.905,1.208-.908l26.7-.042c.67,0,1.211.4,1.211.9l.006,4.178C-123.146,355.057-123.688,355.463-124.358,355.463Z",
    transform: "translate(187.979 -349.372)",
    fill: "#e9f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M-113.963,355.444l-26.7.042c-.667,0-1.211-.4-1.211-.9l-.006-4.178c0-.5.541-.905,1.208-.905l26.7-.042c.67,0,1.211.4,1.211.9l.006,4.175C-112.751,355.038-113.293,355.444-113.963,355.444Z",
    transform: "translate(211.069 -349.407)",
    fill: "#e9f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M-103.568,355.43l-26.7.042c-.667,0-1.211-.4-1.211-.9l-.006-4.175c0-.5.541-.905,1.208-.908l26.7-.042c.67,0,1.211.4,1.211.9l.006,4.178C-102.36,355.024-102.9,355.427-103.568,355.43Z",
    transform: "translate(234.159 -349.445)",
    fill: "#e9f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M-137.35,356.766l-24.414.039c-.744,0-1.346-.287-1.346-.644l0-1.466c0-.358.6-.648,1.343-.648l24.417-.039c.741,0,1.343.287,1.343.641l0,1.469C-136.007,356.475-136.609,356.762-137.35,356.766Z",
    transform: "translate(163.899 -339.309)",
    fill: "#e9f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M-126.6,356.726l-24.414.039c-.744,0-1.346-.287-1.346-.641l0-1.469c0-.354.6-.644,1.343-.647l24.417-.039c.741,0,1.343.287,1.343.644l0,1.469C-125.257,356.437-125.859,356.726-126.6,356.726Z",
    transform: "translate(187.777 -339.396)",
    fill: "#e9f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M-116.144,356.747l-24.417.039c-.741,0-1.343-.287-1.343-.641l0-1.469c0-.354.6-.644,1.343-.647l24.414-.039c.744,0,1.343.287,1.346.644V356.1C-114.8,356.458-115.4,356.747-116.144,356.747Z",
    transform: "translate(211.003 -339.349)",
    fill: "#e9f8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 27.102,
    height: 5.749,
    rx: 0.417,
    transform: "translate(0 38.65) rotate(-0.091)",
    fill: "#e9f8ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(31.732 45.957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M-123.621,362.823l-35.685-.026a3.573,3.573,0,0,1-3.572-3.575l.006-10.737.006-9.864a3.58,3.58,0,0,1,3.579-3.572l35.682.026a3.571,3.571,0,0,1,3.572,3.576l-.013,20.6A3.575,3.575,0,0,1-123.621,362.823Z",
    transform: "translate(162.879 -333.442)",
    fill: "#e9f8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(19.495)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    y2: 28.231,
    transform: "translate(1.611 1.609)",
    fill: "#ffb44f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M-155.216,366a1.607,1.607,0,0,1-1.611-1.611V336.161a1.607,1.607,0,0,1,1.611-1.611,1.609,1.609,0,0,1,1.611,1.611v28.228A1.609,1.609,0,0,1-155.216,366Z",
    transform: "translate(156.827 -334.55)",
    fill: "#266788"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(12.817 6.761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M-145.141,344.751a6.659,6.659,0,0,1-7.535,5.657,6.661,6.661,0,0,1-5.657-7.535,6.661,6.661,0,0,1,7.535-5.656A6.661,6.661,0,0,1-145.141,344.751Z",
    transform: "translate(160.012 -335.537)",
    fill: "#e9f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M-150.608,353.2a8.12,8.12,0,0,1-1.182-.084,8.209,8.209,0,0,1-5.454-3.224,8.22,8.22,0,0,1-1.572-6.13,8.207,8.207,0,0,1,3.224-5.45,8.2,8.2,0,0,1,6.13-1.575,8.215,8.215,0,0,1,5.454,3.224,8.212,8.212,0,0,1,1.575,6.133,8.223,8.223,0,0,1-3.224,5.45A8.219,8.219,0,0,1-150.608,353.2Zm-.029-13.327a5,5,0,0,0-3.018,1.015,5.016,5.016,0,0,0-1.971,3.324,5.058,5.058,0,0,0,4.288,5.714,5.047,5.047,0,0,0,5.718-4.287,5.019,5.019,0,0,0-.96-3.743,5.017,5.017,0,0,0-3.331-1.971A5.038,5.038,0,0,0-150.637,339.871Z",
    transform: "translate(158.9 -336.649)",
    fill: "#266788"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(159.267 18.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M-99.337,343.911A17.676,17.676,0,0,1-93.67,330.8a17.648,17.648,0,0,0-12.009-4.587A17.748,17.748,0,0,0-123.287,344.1a17.747,17.747,0,0,0,17.881,17.6,17.664,17.664,0,0,0,11.938-4.771A17.667,17.667,0,0,1-99.337,343.911Z",
    transform: "translate(123.287 -326.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M-96.3,326.164a17.644,17.644,0,0,0-11.938,4.771,17.667,17.667,0,0,0-5.669,13.107,17.69,17.69,0,0,0,5.869,13.02,17.648,17.648,0,0,0,12.012,4.584,17.743,17.743,0,0,0,17.6-17.878A17.744,17.744,0,0,0-96.3,326.164Z",
    transform: "translate(144.125 -326.164)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(1645.335 416.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(-0.127 -0.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M-116.262,360.411h14.051a1.918,1.918,0,0,1,1.917,1.981l-.57,16.841a1.914,1.914,0,0,0,3.221,1.462l21.164-19.766a1.915,1.915,0,0,1,1.308-.519h29.69a4.192,4.192,0,0,0,4.194-4.191V285.439a4.194,4.194,0,0,0-4.194-4.194h-70.781a4.192,4.192,0,0,0-4.191,4.194V356.22A4.189,4.189,0,0,0-116.262,360.411Z",
    transform: "translate(120.453 -281.245)",
    fill: "#65cefe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(12.734 12.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M-88.742,340.519A27.789,27.789,0,0,1-116.5,312.759,27.787,27.787,0,0,1-88.742,285a27.789,27.789,0,0,1,27.761,27.758A27.792,27.792,0,0,1-88.742,340.519Zm0-52.3a24.564,24.564,0,0,0-24.536,24.536A24.565,24.565,0,0,0-88.742,337.3a24.568,24.568,0,0,0,24.54-24.54A24.567,24.567,0,0,0-88.742,288.222Z",
    transform: "translate(116.5 -285.001)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\u20B9",
    transform: "translate(30.665 54.087)",
    fill: "#fbfeff",
    fontSize: 37,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20B9"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(61.873 59.645)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 41.101,
    height: 41.101,
    rx: 2.285,
    fill: "#ffc34e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M-88.216,322.438a9.655,9.655,0,0,1-9.644-9.645,9.656,9.656,0,0,1,9.644-9.648,9.656,9.656,0,0,1,9.648,9.648A9.656,9.656,0,0,1-88.216,322.438Zm0-17.659a8.022,8.022,0,0,0-8.011,8.014,8.022,8.022,0,0,0,8.011,8.011,8.022,8.022,0,0,0,8.014-8.011A8.023,8.023,0,0,0-88.216,304.779Z",
    transform: "translate(108.765 -292.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M-91.661,316.8a.962.962,0,0,1-.693-.29l-3.814-3.811a.819.819,0,0,1,0-1.156.819.819,0,0,1,1.156,0l3.35,3.35,12.183-12.183a.819.819,0,0,1,1.156,0,.815.815,0,0,1,0,1.153L-91.21,316.749Zm-.464-1.443-.006.006Z",
    transform: "translate(111.994 -293.746)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    transform: "translate(1683.059 618.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    transform: "translate(-0.059 -0.27)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 46.612,
    cy: 46.612,
    r: 46.612,
    fill: "#f9a541"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 32.85,
    cy: 32.85,
    r: 32.85,
    transform: "matrix(0.16, -0.987, 0.987, 0.16, 8.925, 75.162)",
    fill: "#ffc34e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 19.768,
    cy: 19.768,
    r: 19.768,
    transform: "translate(26.844 26.844)",
    fill: "#ffb44f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(19.621 43.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M-81.255,360.543a3.361,3.361,0,0,1-3.363,3.363,3.361,3.361,0,0,1-3.363-3.363,3.361,3.361,0,0,1,3.363-3.363A3.361,3.361,0,0,1-81.255,360.543Z",
    transform: "translate(135.237 -357.18)",
    fill: "#ffb44f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M-95.925,360.543a3.361,3.361,0,0,1-3.363,3.363,3.361,3.361,0,0,1-3.363-3.363,3.361,3.361,0,0,1,3.363-3.363A3.361,3.361,0,0,1-95.925,360.543Z",
    transform: "translate(102.651 -357.18)",
    fill: "#ffb44f"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": "\\u20B9",
    transform: "translate(35.941 60.73)",
    fill: "#f79d31",
    fontSize: 37,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20B9"))), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": "\\u20B9",
    transform: "translate(1549 532)",
    fill: "#fbfeff",
    fontSize: 66,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20B9")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/Card.9b75a17598dab1a266a32ff5f2852b3d.svg";
export { ForwardRef as ReactComponent };